import React from 'react';
import { ListOrdered } from 'lucide-react';
import {
  belotMatchCpFromEnginePoints,
  belotMatchTargetCpFromEngine,
} from '../../game/belotArmenianCards';
import { cn } from '../../poker-ui/utils/cn';

/**
 * Верхняя инфо-панель портретного стола (Candy-style): счёт до лимита, козырь и множитель раунда.
 */
export function BelotPortraitMatchBar({
  engineState,
  targetScore,
  onAuctionLogClick,
}) {
  const tsEng = Number(engineState?.targetScore ?? targetScore) || 10010;
  const ts = belotMatchTargetCpFromEngine(tsEng);
  const s0 = belotMatchCpFromEnginePoints(Number(engineState?.teamScores?.[0]) || 0);
  const s1 = belotMatchCpFromEnginePoints(Number(engineState?.teamScores?.[1]) || 0);
  const t0 = Number(engineState?.tricksWonByTeam?.[0]) || 0;
  const t1 = Number(engineState?.tricksWonByTeam?.[1]) || 0;
  const roundIdx = Number(engineState?.roundIndex) || 0;
  const inAuction = engineState?.phase === 'auction';
  const showAuctionLogBtn = Boolean(inAuction && typeof onAuctionLogClick === 'function');

  return (
    <div
      className={cn(
        'relative z-[28] shrink-0 px-2 py-1 sm:px-3',
      )}
    >
      <div className="relative mx-auto flex max-w-lg items-center gap-1.5 sm:gap-2">
        <div className="min-w-0 flex-1 rounded-md border border-white/10 bg-black/20 px-2 py-1 text-[10px] font-mono tabular-nums text-slate-200/95">
          {roundIdx + 1} · {t0}:{t1}
        </div>
        {showAuctionLogBtn ? (
          <button
            type="button"
            onClick={() => onAuctionLogClick()}
            className={cn(
              'flex shrink-0 items-center gap-1 rounded-md border border-amber-400/35 bg-amber-950/35 px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-amber-100',
              'transition hover:border-amber-300/55 hover:bg-amber-900/45',
            )}
            title="Полный лог торгов"
            aria-label="Открыть полный лог торгов"
          >
            <ListOrdered className="h-3.5 w-3.5 shrink-0 opacity-90" aria-hidden />
            <span className="hidden min-[360px]:inline">Лог</span>
          </button>
        ) : null}
        <div className="min-w-0 flex-1 rounded-md border border-white/10 bg-black/20 px-2 py-1 text-right text-[11px] font-mono font-bold tabular-nums text-amber-100">
          {s0}:{s1} / {ts}
        </div>
      </div>
    </div>
  );
}
